/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AllShipmentsWeekdayAverage
 */
export interface AllShipmentsWeekdayAverage {
  /**
   *
   * @type {string}
   * @memberof AllShipmentsWeekdayAverage
   */
  day: string;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsWeekdayAverage
   */
  quoted: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsWeekdayAverage
   */
  booked: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsWeekdayAverage
   */
  revenue: number;
}

/**
 * Check if a given object implements the AllShipmentsWeekdayAverage interface.
 */
export function instanceOfAllShipmentsWeekdayAverage(
  value: object,
): value is AllShipmentsWeekdayAverage {
  if (!("day" in value) || value["day"] === undefined) return false;
  if (!("quoted" in value) || value["quoted"] === undefined) return false;
  if (!("booked" in value) || value["booked"] === undefined) return false;
  if (!("revenue" in value) || value["revenue"] === undefined) return false;
  return true;
}

export function AllShipmentsWeekdayAverageFromJSON(
  json: any,
): AllShipmentsWeekdayAverage {
  return AllShipmentsWeekdayAverageFromJSONTyped(json, false);
}

export function AllShipmentsWeekdayAverageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AllShipmentsWeekdayAverage {
  if (json == null) {
    return json;
  }
  return {
    day: json["day"],
    quoted: json["quoted"],
    booked: json["booked"],
    revenue: json["revenue"],
  };
}

export function AllShipmentsWeekdayAverageToJSON(
  json: any,
): AllShipmentsWeekdayAverage {
  return AllShipmentsWeekdayAverageToJSONTyped(json, false);
}

export function AllShipmentsWeekdayAverageToJSONTyped(
  value?: AllShipmentsWeekdayAverage | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    day: value["day"],
    quoted: value["quoted"],
    booked: value["booked"],
    revenue: value["revenue"],
  };
}
